import { IssueData, ZodIssueCode } from 'zod';
import { doesExist, isString } from 'utils/tsHelpers';
import { isEmptyString } from 'utils/stringHelpers';
import { validateDate as hasDateError } from 'utils/validateDate';
import { validateDateRangeValue } from './validateDateRangeValue';
import { Comparator, DateComparator, DateRange, FieldType } from '../../types';

/**
 * Util to validate dates.
 * Checks if date is an epoch time stamp or relative date string (ie: "now - 5d")
 */
export const validateDateValue = (
  {
    value,
    fieldType,
    comparatorType,
  }: {
    value?: string | DateRange;
    fieldType: FieldType;
    comparatorType?: Comparator;
  },
  addIssue: (arg: IssueData) => void,
) => {
  if (comparatorType === DateComparator.BETWEEN) {
    validateDateRangeValue({ value }, addIssue);
  }
  if (
    fieldType === FieldType.DATE &&
    doesExist(value) &&
    isString(value) &&
    !isEmptyString(value) &&
    hasDateError(value)
  ) {
    addIssue({
      code: ZodIssueCode.custom,
      message: 'invalid date',
      path: ['value'],
    });
  }
};
